import React, { useEffect, useState } from "react";
import showToast from "helpers/showToast";
import apiCall from "services/apiCall";
import {
  getAssesmentMessage,
  getSessionStudentMultipleExamResult
} from "services/exam/session-service";
import IconLoader from "components/IconLoader/IconLoader";
import DataGridLoadingAnimation from "components/Animations/DataGridLoadingAnimation";
import SessionStudentResult from "./SessionStudentResult";
import EmptyTableAnimation from "components/Animations/EmptyTableAnimation";
import { isArray, isDate } from "lodash";

export default function SessionExamResults({ identityNumber, changeMultiplePageMode }) {
  const [loading, setLoading] = useState(false);
  const [pastExams, setPastExams] = useState([]);
  const [activeExams, setActiveExams] = useState([]);
  const [activeTab, setActiveTab] = useState("active");

  useEffect(() => {
    if (identityNumber) {
      getResultsFromApi();
    }
  }, [identityNumber]);

  const getResultsFromApi = async () => {
    setLoading(true);
    await apiCall({
      service: getSessionStudentMultipleExamResult,
      serviceParams: identityNumber,
      onSuccess: (resultRes) => {
        if (isArray(resultRes?.data)) {
          resultRes.data.reverse();
        }

        const currentDate = new Date();
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo?.setDate(currentDate.getDate() - 30);

        const pastExams = [];
        const activeExams = [];
        resultRes?.data?.forEach((exam) => {
          const answerPublishDate = new Date(exam?.answerPublishDate);

          if (answerPublishDate < thirtyDaysAgo && isDate(answerPublishDate)) {
            pastExams.push(exam);
          } else {
            activeExams.push(exam);
          }
        });

        const assesmentIdList =
          resultRes?.data
            ?.filter((resultObj) => resultObj?.examAssesmentDO?.id)
            ?.map((resultObj) => resultObj?.examAssesmentDO?.id) || [];

        if (assesmentIdList?.length > 0) {
          apiCall({
            service: getAssesmentMessage,
            serviceParams: assesmentIdList,
            onSuccess: (messageRes) => {
              const addMessagesToExams = (exams) =>
                exams.map((exam) => {
                  const messageObj = messageRes?.data?.find(
                    (msg) => msg?.examAssesmentId === exam?.examAssesmentDO?.id
                  );
                  return {
                    ...exam,
                    message: messageObj?.message || null
                  };
                });

              setPastExams(addMessagesToExams(pastExams));
              setActiveExams(addMessagesToExams(activeExams));
              setLoading(false);
            },
            onError: () => {
              setLoading(false);
            }
          });
        } else {
          setPastExams(pastExams);
          setActiveExams(activeExams);
          setLoading(false);
        }
      },
      onError: () => {
        setLoading(false);
        showToast("Sınav sonuçları getirme işlemi sırasında hata oluştu.", { type: "error" });
      }
    });
  };

  return (
    <>
      {loading ? (
        <div className="d-flex flex-column align-items-center justify-content-center my-40">
          <DataGridLoadingAnimation height={300} width={300} />
        </div>
      ) : (
        <div className="container pt-6" style={{ position: "relative" }}>
          <button
            onClick={() =>
              changeMultiplePageMode([
                { name: "examResults", open: false },
                { name: "registerMenu", open: true }
              ])()
            }
            className="btn btn-primary d-none d-lg-block"
            style={{ position: "absolute", left: -85 }}
          >
            <IconLoader icon="mdiChevronLeft" size={1} />
          </button>

          <div className="d-flex w-100 justify-content-center">
            <img src="/media/register/registerTitleImage.png" style={{ maxWidth: "100%" }} />
          </div>

          <div className="d-flex justify-content-center mt-12">
            <div className="btn-group" role="group">
              <button
                type="button"
                className={`btn ${activeTab === "active" ? "btn-primary" : "btn-light"}`}
                onClick={() => setActiveTab("active")}
              >
                Sınav Sonuçlarım
              </button>
              <button
                type="button"
                className={`btn ${activeTab === "past" ? "btn-primary" : "btn-light"}`}
                onClick={() => setActiveTab("past")}
              >
                Geçmiş Sınav Sonuçlarım
              </button>
            </div>
          </div>

          {activeTab === "active" && (
            <div>
              {activeExams.length > 0 ? (
                activeExams.map((exam, index) => (
                  <SessionStudentResult key={index} resultObject={exam} />
                ))
              ) : (
                <div className="d-flex flex-column align-items-center p-xl-16 p-lg-14 p-md-10 p-6">
                  <div className="d-flex flex-column align-items-center w-100">
                    <span className="font-weight-bold mt-4 h6">
                      Girmiş olduğunuz TC kimlik numarası ile eşleşen bir sınav sonucu
                      bulunamamıştır. Eğer sınava girmişseniz lütfen girdiğiniz kurum ile görüşünüz.
                    </span>
                    <EmptyTableAnimation height={100} />
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === "past" && (
            <div>
              {pastExams.length > 0 ? (
                pastExams.map((exam, index) => (
                  <SessionStudentResult key={index} resultObject={exam} />
                ))
              ) : (
                <div className="d-flex flex-column align-items-center p-xl-16 p-lg-14 p-md-10 p-6">
                  <div className="d-flex flex-column align-items-center w-100">
                    <span className="font-weight-bold mt-4 h6">
                      Girmiş olduğunuz TC kimlik numarası ile eşleşen bir sınav sonucu
                      bulunamamıştır. Eğer sınava girmişseniz lütfen girdiğiniz kurum ile görüşünüz.
                    </span>
                    <EmptyTableAnimation height={100} />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}
